import { IApiResponse, ISocialMediaItem } from "../models/Interfaces";
import { BaseService } from "./BaseService";


export class SocialMediaService extends BaseService {

  public getSocialMediaItems = async () : Promise<Array<ISocialMediaItem>> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/GetSocialMediaItems/${this.siteKey}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve social media items");
        }
      }
    }
    return [];
  }

  public deleteSocialMediaItem = async (id: number) : Promise<boolean> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/DeleteSocialMedia/${this.siteKey}/${id}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200) {
        return true;
      } else {
        this.EmitDataError(res, "Failed to delete social media item");
      }
    }
    return false;
  }

  public saveSocialMediaItem = async (item: ISocialMediaItem) : Promise<ISocialMediaItem | null> => {
    if (this.siteKey && item) {
      const url: string = `/SiteAdmin/AddUpdateSocialMedia`;
      const res = await this._ajaxService.Post<IApiResponse>(url, item, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save social media item");
      }
    }
    return null;
  }

  public newSocialMediaItem = () : ISocialMediaItem | null => {
    if (this.siteKey) {
      return {
        Id: 0,
        SiteId: this.siteKey,
        AltText: "",
        IconClass: "",
        ImageUrl: "",
        Name: "",
        SiteName: "",
        Url: ""
      };
    }
    return null;
  }
}